export enum FileUploader {
  EMA = 'ema',
  MECHANISCHE_SICHERUNGEN = 'mechanische-sicherungen',
  ELEMENTAR_FRAGEBOGEN = 'elemntar-fragebogen',
  NEBENGEBAEUDE_FOTOS = 'nebengebaeude-fotos',
  TRESOR = 'tresor-',
}
